export default "__VITE_ASSET__CDLoIym___"